const infoList = [
  {
    name: '鑫达商务广场（共2栋）',
    minAcreage: '25952.98',
    maxAcreage: '',
    coordinate: '31.230261,121.360875',
    location: '协和路1158号、北翟路1178号',
    synopsis: ' 位于上海宁区北翟路协和路口，交通便捷。园区共两栋商务楼组成，外立面白色墙砖搭配蓝绿色玻璃幕墙。园区配套全面，保安、保洁等物业服务到位。一楼大堂配有书吧、咖啡吧、免费健身区、地下配有白领员工食堂等设施、入驻企业有鑫达实业、新泾镇经济发展服务中心等企业单位。',
    img: require('@/assets/images/gateway/park/_MG_8643.jpg'),
    imgList: [{
      title: '户外图',
      src: '_MG_8710',
      srcList: ['_MG_8643', '_MG_8652', '_MG_8710', '_MG_8711', 'IMG_9185', '_MG_8724', 'IMG_9206', 'IMG_9219', 'shangwuguangchang']
    }]
  },
  {
    name: '虹桥科技广场D座',
    minAcreage: '10773',
    maxAcreage: '',
    coordinate: '31.225463,121.358675',
    location: '金钟路999号D栋',
    synopsis: ' 位于上海虹桥临空经济园区，毗邻虹桥综合交通枢纽；项目按照5A级研发中心为标准进行设计建造，依照园林式、高科技、总部型的定位理念打造的高端商务办公楼，入驻企业有携程、丰巢科技、平安保险等。',
    img: require('@/assets/images/gateway/park/IMG_8962.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8962',
      srcList: ['IMG_8962', 'hongqiaokeji']
    }]
  },
  {
    name: '虹桥中央大厦',
    minAcreage: '12189',
    maxAcreage: '',
    coordinate: '31.225061,121.366114',
    location: '金钟路631弄2号',
    synopsis: ' 虹桥中央大厦，2号线地铁口上盖，交通条件无上优越，大虹桥区域内的总部经济样板办公楼，入驻企业有仲利国际、佳杰科技等高端企业。',
    img: require('@/assets/images/gateway/park/IMG_8950.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8950',
      srcList: ['IMG_8953', 'hongqiaozhongyang']
    }]
  },
  {
    name: '鑫达产业园',
    minAcreage: '25344.77',
    maxAcreage: '',
    coordinate: '31.240882,121.355735',
    location: '临新路268号（9/10/11/16栋）',
    synopsis: ' 位于长宁区临新路近协和路，处于虹桥临空商圈内，外观简洁现代，配套设施齐全，物业管理规范；周边环境优越，交通便利，是商务精英发展事业、总部式办公的睿智之选；现园区已入驻企业有美国联合利华、德国博世等。',
    img: require('@/assets/images/gateway/park/IMG_8985.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_9001',
      srcList: ['IMG_9001', 'IMG_8992', 'IMG_8995', 'IMG_8988', 'IMG_8989', 'xindachanyeyuan']
    }]
  },
  {
    name: '鑫达大厦',
    minAcreage: '5891',
    maxAcreage: '',
    coordinate: '31.211268,121.405669',
    location: '仙霞路318-322号',
    synopsis: ' 鑫达大厦为纯商务高级写字楼，总高26层，大厦由名师精心设计，外型结构别致典雅，呈两个扇形合报状；大厦为商务办公用房，办公室可灵活分隔。',
    img: require('@/assets/images/gateway/park/IMG_8923.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8923',
      srcList: ['IMG_8925', 'IMG_8926', 'xindadasha']
    }]
  },
  {
    name: '鑫达财富中心',
    minAcreage: '3269',
    maxAcreage: '',
    coordinate: '31.226368,121.368298',
    location: '淞虹路152号',
    synopsis: '位于金钟路淞虹路口，4层建筑，入驻单位有农商银行、申万宏源证券等金融机构',
    img: require('@/assets/images/gateway/park/IMG_8948.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8948',
      srcList: ['IMG_8948', 'caifuzhongxin']
    }]
  },
  {
    name: '新泾镇社区事务受理服务中心',
    minAcreage: '1690',
    maxAcreage: '',
    coordinate: '31.217795,121.378889',
    location: '哈密路431号',
    synopsis: '政府机关、事业单位配套用房项目。',
    img: require('@/assets/images/gateway/park/IMG_8940.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8940',
      srcList: ['IMG_8941', 'xinjingfuwuzhongxin']
    }]
  },
  {
    name: '同仁医院（共3栋）',
    minAcreage: '16811',
    maxAcreage: '',
    coordinate: '31.218296,121.38042',
    location: '哈密路419号、哈密路431号',
    synopsis: '上海市同仁医院教学楼、病房楼用房项目。',
    img: require('@/assets/images/gateway/park/IMG_8930.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8930',
      srcList: ['IMG_8930', 'IMG_8933', 'IMG_8929', 'IMG_8932', 'tongren']
    }]
  },
  {
    name: '茂星广场',
    minAcreage: '51599',
    maxAcreage: '',
    coordinate: '31.17215,121.35027',
    location: '七莘路3558号、吴宝路655号',
    synopsis: ' 位于闵行区七宝凯德购物广场对面，附近商圈成熟，交通便利。 ',
    img: require('@/assets/images/gateway/park/IMG_8978.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8974',
      srcList: ['IMG_8978', 'IMG_8980', 'IMG_8981', 'IMG_8982', 'IMG_8983', 'maoxing']
    }]
  },
  {
    name: '海益商务大厦',
    minAcreage: '14028.23',
    maxAcreage: '',
    coordinate: '31.2213,121.391558',
    location: '天山路310、316号',
    synopsis: ' 位于威宁路天山路口，轨交二号线贯穿左右，交通便捷。东侧有缤谷广场，商业气息浓厚，医疗、教育、休闲购物设施一应俱全。',
    img: require('@/assets/images/gateway/park/IMG_8901.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8901',
      srcList: ['IMG_8901', 'IMG_8906', 'haiyi']
    }]
  },
  {
    name: '海盈商务楼5F',
    minAcreage: '1268.42',
    maxAcreage: '',
    coordinate: '31.218221,121.391221',
    location: '威宁路333号',
    synopsis: '位于威宁路新渔东路口，为6层建筑，由上海海盈房地产开发有限公司建成。',
    img: require('@/assets/images/gateway/park/IMG_8922.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8922',
      srcList: ['IMG_8922', 'IMG_8908', 'haiying']
    }]
  },
  {
    name: '铭晖商务楼',
    minAcreage: '2218',
    maxAcreage: '',
    coordinate: '31.217309,121.380994',
    location: '哈密路422号-444号',
    synopsis: '位于北新泾泉口路近哈密路，临近地铁2号线北新泾站。',
    img: require('@/assets/images/gateway/park/IMG_8939.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8939',
      srcList: ['IMG_8939', 'IMG_8937', 'yinghui']
    }]
  },
  {
    name: '可乐路房屋',
    minAcreage: '827',
    maxAcreage: '',
    coordinate: '31.211016,121.373309',
    location: '可乐路49-67号',
    synopsis: '政府机关、事业单位配套用房项目。',
    img: require('@/assets/images/gateway/park/IMG_8943.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8943',
      srcList: ['IMG_8943', 'kele']
    }]
  },
  {
    name: '新渔东路商铺',
    minAcreage: '5994.43',
    maxAcreage: '',
    coordinate: '31.218097,121.392638',
    location: '新渔东路388、394号',
    synopsis: '为天山星城小区配套商业用房，有中信银行、美天菜市场等配套单位入驻',
    img: require('@/assets/images/gateway/park/IMG_8907.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8907',
      srcList: ['IMG_8907', 'IMG_8909', 'IMG_8910', 'IMG_8919', 'xinyudonglu']
    }]
  },
  {
    name: '鑫达科研楼',
    minAcreage: '4579.09',
    maxAcreage: '',
    coordinate: '31.223048,121.361152',
    location: '广顺路33号A南座',
    synopsis: '园区整体正在进行城市升级改造更新。',
    img: require('@/assets/images/gateway/park/IMG_7234.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_7234',
      srcList: ['IMG_7234', 'IMG_7243', 'IMG_7246', 'keyan']
    }]
  },
  {
    name: '青浦重固外基地',
    minAcreage: '18436.79',
    maxAcreage: '',
    coordinate: '31.196171,121.202984',
    location: '北青公路6285号1-6幢',
    synopsis: '6幢以仓储功能为主的房屋，周边有88万平米的上海意邦建材家居世界',
    img: require('@/assets/images/gateway/park/IMG_8964.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8973',
      srcList: ['IMG_8964', 'IMG_8969', 'IMG_8967', 'guzhong']
    }]
  },
  {
    name: '新泾派出所',
    minAcreage: '3710',
    maxAcreage: '',
    coordinate: '31.2166,121.376337',
    location: '剑河路500号',
    synopsis: '政府机关、事业单位配套用房项目。',
    img: require('@/assets/images/gateway/park/IMG_8947.jpg'),
    imgList: [{
      title: '户外图',
      src: 'IMG_8946',
      srcList: ['IMG_8947', 'pcs']
    }]
  },
]
export default infoList